import KeenSlider from "keen-slider";

let dots;

const navigation = (slider) => {
	/* console.log(slider); */
	dots = document.querySelectorAll(".global-steps__slider-controls .slider-controls__dot");
	dots.forEach((el, i) => (el.dataset.index = i));
	dots[0].dataset.active = true;
	//
	const leftBtn = document.querySelector(
		".global-steps__slider-controls .slider-controls__btn-wrap .circle-arrow-btn[data-dir=left]"
	);
	const rightBtn = document.querySelector(
		".global-steps__slider-controls .slider-controls__btn-wrap .circle-arrow-btn[data-dir=right]"
	);
	//
	leftBtn.addEventListener("click", slider.prev);
	rightBtn.addEventListener("click", slider.next);
	slider.on("slideChanged", updateDots);
};

const updateDots = (e) => {
	dots.forEach((el) => (el.dataset.active = false));
	dots[e.track.details.rel].dataset.active = true;
};

export default function () {
	if (document.getElementById("global-steps-slider")) {
		new KeenSlider(
			"#global-steps-slider",
			{
				loop: true,
				slides: {
					perView: 1,
					spacing: 16,
				},
				breakpoints: {
					"(min-width: 768px)": {
						slides: {
							perView: 2,
						},
					},
					"(min-width: 992px)": {
						disabled: true,
					},
				},
			},
			[navigation]
		);
	}
}
